import React, { useMemo } from "react";
import "./ReleaseStatsBar.css";

/**
 * ReleaseStatsBar
 * Shows summary count cards: Total, DRAFT, READY, RELEASED.
 * Derived from the releases data already fetched by API 1 — no extra API call.
 *
 * @param {object[]} releases - full list of releases from API 1
 * @param {string}   activeStatus - currently selected status filter
 * @param {function} onStatusClick - called with the status string when a card is clicked
 */
const ReleaseStatsBar = ({ releases = [], activeStatus, onStatusClick }) => {
    const stats = useMemo(() => {
        const draft = releases.filter((r) => r.status === "DRAFT").length;
        const ready = releases.filter((r) => r.status === "READY").length;
        const released = releases.filter((r) => r.status === "RELEASED").length;
        return { total: releases.length, draft, ready, released };
    }, [releases]);

    const cards = [
        {
            key: "",
            label: "Total",
            count: stats.total,
            className: "release-stats-bar__card--total",
        },
        {
            key: "DRAFT",
            label: "Draft",
            count: stats.draft,
            className: "release-stats-bar__card--draft",
        },
        {
            key: "READY",
            label: "Ready",
            count: stats.ready,
            className: "release-stats-bar__card--ready",
        },
        {
            key: "RELEASED",
            label: "Released",
            count: stats.released,
            className: "release-stats-bar__card--released",
        },
    ];

    return (
        <ul className="release-stats-bar" role="list" aria-label="Release status summary">
            {cards.map(({ key, label, count, className }) => (
                <li key={key || "total"} className="release-stats-bar__item">
                    <button
                        type="button"
                        className={`release-stats-bar__card ${className} ${activeStatus === key ? "release-stats-bar__card--active" : ""
                            }`}
                        onClick={() => onStatusClick && onStatusClick(key)}
                        aria-pressed={activeStatus === key}
                        aria-label={`${label}: ${count} releases`}
                    >
                        <span className="release-stats-bar__count">{count}</span>
                        <span className="release-stats-bar__label">{label}</span>
                    </button>
                </li>
            ))}
        </ul>
    );
};

export default ReleaseStatsBar;
